const state = {
  isShow: false,
  updateHoliday: false,
  dataSetting: {}
}
const getters = {
  isShow (state) {
    return state.isShow
  },
  updateHoliday (state) {
    return state.updateHoliday
  },
  dataSetting (state) {
    return state.dataSetting
  }
}

const mutations = {
  OPEN_POPUP (state, dataPopup) {
    state.isShow = true
    state.dataSetting = dataPopup
  },
  CLOSE_POPUP (state) {
    state.isShow = false
    state.dataSetting = {}
  },
  UPDATE_HOLIDAY_COMPLETE(state, data) {
    state.updateHoliday = data
  },
  INIT_STATE_HOLIDAY(state) {
    state.isShow = false
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
